import 'classlist-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { getJSON, datain } from './utils'

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$jsonp = getJSON
Vue.prototype.$datain = datain

Vue.directive('datain', {
  bind: (el, binding) => {
    el.addEventListener('click', () => {
      datain(binding.value)
    })
  },
  unbind: (el, binding) => {
    el.removeEventListener('click', () => {
      datain(binding.value)
    })
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
